import React from 'react';
import { Link } from 'react-router-dom';
import { compose, withHandlers } from 'recompose';
import { reduxForm, Field } from 'redux-form';
import {Button, Grid} from '@material-ui/core/';
import withStyles from '@material-ui/core/styles/withStyles';
import { TextField} from 'redux-form-material-ui';

const required = (value) => (value || typeof value === 'number' ? undefined : 'Vyžadováno');
const email = (value) =>
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
    ? 'Neplatný formát emailu'
    : undefined;
const maxLength = (max) => (value) =>
  value && value.length > max ? `Je povoleno maximálně ${max} znaků` : undefined;
const maxLength256 = maxLength(256);

const styles = (theme) => ({
  section: {
    marginBottom: 25,
  },
  textFields: {
    width: '80%',
  },
  buttons: {
    margin: '0 5px',
  },
});

const enhance = compose(
  withStyles(styles),
  withHandlers({}),
  reduxForm({ form: 'helpdeskForm' })
);

export default enhance(({ classes, handleSubmit }) => (
  <form className={classes.form} onSubmit={handleSubmit}>
    <div className={classes.section}>
      <Grid container spacing={24}>
        <Grid item xs={3}>
          <Field
            name="email"
            component={TextField}
            label="Email zadavatele"
            className={classes.textFields}
            validate={[required, email, maxLength256]}
          />
        </Grid>
        <Grid item xs={9} />
        <Grid item xs={12}>
          <Field
            name="text"
            component={TextField}
            label="Popis chyby / návrh vylepšení"
            className={classes.textFields}
            validate={[required]}
            multiline
            rows={5}
            fullWidth
          />
        </Grid>
      </Grid>
    </div>
    <Grid container spacing={8} />
    <div style={{ marginTop: 20 }}>
      <Button type="submit" variant="contained" color="primary" className={classes.buttons}>
        Odeslat
      </Button>
      <Button
        variant="contained"
        color="secondary"
        component={(props) => <Link to="/" {...props} />}
        className={classes.buttons}
      >
        Zrušit
      </Button>
    </div>
  </form>
));



// WEBPACK FOOTER //
// ./src/modules/helpdesk/detail/helpdeskForm.js